// Game entry (game.html): carry storage over from the old origin first, then load the game,
// so settingsStore and the autosave read what was migrated (see originMigration.ts).
import { migrateFromOldOrigin } from './config/originMigration.js';

void migrateFromOldOrigin().then(() => import('./main.js'));
